import React, { useContext, useEffect, useState } from "react";
import { userContext } from "../context/UserContext";
import { useTranslation } from "react-i18next";

function QaariPackageDetails(props) {
  // const { cart,AddToCart } = useContext(userContext)
  const { Qaaripackages, QaariAllDetails, setShowModal } = props;
  const { t } = useTranslation();

  return (
    <div className="item">
      <div className="dark-card package-card">
        <div className="res-pac-img package-pac-img mb-3">
          <h3 className="font-bold">{Qaaripackages?.package_name}</h3>
        </div>
        <div className="res-pac-detail text-start">
          <h4 className="font-bold">{Qaaripackages?.package_unit_price}KD</h4>
          {Qaaripackages?.package_time && (
            <h6>{t("zakiriPage.duration")} {Qaaripackages?.package_time} Minutes</h6>
          )}
          <p className="text-light">{Qaaripackages?.package_description}</p>
        </div>
        <div className="res-pac-detail">
          <button
            onClick={() => {
              console.log(Qaaripackages);
              setShowModal({
                show: true,
                details: Qaaripackages,
              });
            }}
            className="btn btn-primary w-100"
          >
            {t("zakiriPage.reservation")}
          </button>
        </div>
      </div>
    </div>
  );
}

export default QaariPackageDetails;
